import React from "react";
import { useEffect, useState } from "react";
import { UrlApi } from "../../../../../services/apirest";
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Autocomplete,
  Tooltip,
  IconButton,
  Grid,
} from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import ContactsIcon from "@mui/icons-material/Contacts";
import PushPinIcon from "@mui/icons-material/PushPin";
import InputAdornment from "@mui/material/InputAdornment";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import BadgeIcon from "@mui/icons-material/Badge";
import Notify from "../../../../Notify";
import MapaDireccionEnv from "./MapaDireccionEnv";
import PropaneIcon from "@mui/icons-material/Propane";
import DialogProPre from "../../alta/DialogProPre";
import { registrarAccion, describirCambios, DONDE } from "../../../logs/registrarAccion";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";

function EdicionDireccionEnv(props) {
  const size = "small";
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };
  const [datosformulario, setDatosformulario] = useState(props.direccion);
  const [buscando, setBuscando] = useState(false);
  const [provinciaSeleccionada, setProvinciaSeleccionada] = useState("");
  const [localidadSeleccionada, setLocalidadSeleccionada] = useState("");
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");
  const [productoPredeterminado, setProductoPredeterminado] = useState(false);
  const [zonaSeleccionada, setZonaSeleccionada] = useState("");
  const [geozonasPorDomicilio, setGeozonasPorDomicilio] = useState({});
  const [loading, setLoading] = useState(true);
  const [localidades, setLocalidades] = useState(null);
  const [provincias, setProvincias] = useState(null);
  const [sucursales, setSucursales] = useState(null);
  const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
  const [openSnack, setOpenSnack] = React.useState(false); //abre y cierra snack
  const [mensaje, setMensaje] = useState(""); //mensaje q mostrará la notif
  const [error, setError] = useState(null); //guardará el error que lance la api (si existe)
  const [mensajeAlerta, setMensajeAlerta] = useState(""); //mensaje que contendrá el componente "alerta"
  const [zonas, setZonas] = useState(null);
  const [codArg, setCodArg] = useState("");
  const [disBtn, setDisBtn] = useState(false);

  useEffect(() => {
    props.direccion &&
      setDatosformulario({
        ...props.direccion,
        telefono_1: props.direccion.telefono_1
          ? props.direccion.telefono_1.replace(/^(\+?549)?(\d{10})$/, "$2")
          : "",
        telefono_2: props.direccion.telefono_2
          ? props.direccion.telefono_2.replace(/^(\+?549)?(\d{10})$/, "$2")
          : "",
        telefono_3: props.direccion.telefono_3
          ? props.direccion.telefono_3.replace(/^(\+?549)?(\d{10})$/, "$2")
          : "",
      });
  }, [props.direccion]);

  const almacenar = (e) => {
    setDatosformulario({
      ...datosformulario,
      [e.target.name]: e.target.value === "" ? null : e.target.value,
    });
  };

  const getCodArg = () => {
    fetch(UrlApi + "/desplegables/codArg")
      .then((data) => data.json())
      .then((data) => setCodArg(data[0].valor));
  };

  const obtenerLocalidades = () => {
    fetch(UrlApi + "/localidades/prov/" + provinciaSeleccionada.id)
      .then((data) => data.json())
      .then((data) => setLocalidades(data))
      .then(() => setBuscando(false));
  };

  const obtenerSuc = () => {
    fetch(UrlApi + "/sucursales")
      .then((data) => data.json())
      .then((data) => setSucursales(data));
  };

  const obtenerProvincias = () => {
    fetch(UrlApi + "/provincias")
      .then((data) => data.json())
      .then((data) => setProvincias(data));
  };

  useEffect(() => {
    obtenerSuc();
  }, []);

  useEffect(() => {
    obtenerProvincias();
    getCodArg();
  }, []);

  useEffect(() => {
    obtenerLocalidades();
    if (!(props.direccion.id_provincia === provinciaSeleccionada.id)) {
      setLocalidadSeleccionada("");
    }
  }, [provinciaSeleccionada]);

  //Funcion para guardar la direccion de entrega
  async function guardarDireccion(e) {
    setDisBtn(true);
    e.preventDefault();
    const datosGuardar = {
          direccion_entrega: datosformulario.direccion_entrega,
          contacto: datosformulario.contacto,
          telefono_1: datosformulario.telefono_1,
          telefono_2: datosformulario.telefono_2,
          telefono_3: datosformulario.telefono_3,
          mails: datosformulario.mails,
          latitud: datosformulario.latitud,
          longitud: datosformulario.longitud,
          // id_cliente: datosformulario.id_cliente,
          id_localidad: localidadSeleccionada.id,
          id_ruta:
            datosformulario.id_ruta === "" ? null : datosformulario.id_ruta,
          // id_provincia: provinciaSeleccionada.id,
          usuario: localStorage.getItem("user"),
          nombre_direccion: datosformulario.nombre_direccion,
          id_sucursal: sucursalSeleccionada.id,
          observaciones: datosformulario.observaciones,
          zona: zonaSeleccionada.id,
        };
    const response = await fetch(
      UrlApi + "/envasado_direcciones_entrega/" + datosformulario.id,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(datosGuardar),
      }
    );

    // Log de cambios: el "antes" sale de props.direccion (trae nombres de localidad, sucursal y zona)
    const logEdicion = () => {
      const quitar549 = (t) => (t ? t.replace(/^(\+?549)?(\d{10})$/, "$2") : "");
      const antes = {
        ...props.direccion,
        telefono_1: quitar549(props.direccion.telefono_1),
        telefono_2: quitar549(props.direccion.telefono_2),
        telefono_3: quitar549(props.direccion.telefono_3),
        id_localidad: props.direccion.localidad ?? props.direccion.id_localidad,
        id_sucursal: props.direccion.sucursal ?? props.direccion.id_sucursal,
        zona: props.direccion.nombre_zona ?? props.direccion.zona,
      };
      const despues = {
        ...datosGuardar,
        id_localidad: localidadSeleccionada?.localidad ?? datosGuardar.id_localidad,
        id_sucursal: sucursalSeleccionada?.nombre ?? datosGuardar.id_sucursal,
        zona: zonaSeleccionada?.nombre ?? datosGuardar.zona,
      };
      const cambios = describirCambios(antes, despues, {
        nombre_direccion: "Nombre",
        direccion_entrega: "Dirección",
        id_localidad: "Localidad",
        id_sucursal: "Sucursal",
        zona: "Zona",
        contacto: "Contacto",
        telefono_1: "Teléfono 1",
        telefono_2: "Teléfono 2",
        telefono_3: "Teléfono 3",
        mails: "Mails",
        latitud: "Latitud",
        longitud: "Longitud",
        id_ruta: "Ruta (ID)",
        observaciones: "Observaciones",
      });
      if (cambios) {
        registrarAccion(
          DONDE.CLIENTES,
          `Editó dirección ${datosformulario.id} del cliente ${props.direccion.idCliente}: ${cambios}`
        );
      }
    };

    if (response.ok === false) {
      const error = response && response.json();
      setError(error);
      setMensajeAlerta("Inconvenientes con la API. No se pudo guardar. ");
      props.setOpen(false);
    } else {
      try {
        const json = await response.json();
        if (json.message) {
          logEdicion();
          setNotificacion(true);
          setOpenSnack(true);
          setMensaje(
            json.message === "OK" ? "Guardado" : "Guardado. Actualizar RTA Api"
          );
          props.actualizar();
        } else if (json.sqlMessage) {
          json && setError(json);
          alert(
            "NO SE PUDO ACTUALIZAR LA DIRECCIÓN DE ENTREGA. SQL erróneo (" +
              json.code +
              " Errno: " +
              json.errno +
              " )"
          );
          props.setOpen(false);
        } else {
          alert("ERROR DESCONOCIDO: " + error);
        }
      } catch (error) {
        if (error.toString().includes("is not valid JSON")) {
          logEdicion();
          alert("Edición Guardada.");
          props.actualizar();
        } else {
          setNotificacion(true);
          setOpenSnack(true);
          setMensaje("Guardado. Actualizar RTA API a Json.");
          props.setOpen(false);
        }
      }
    }
  }

  // guardar el estado de lo seleccionado y que se ponga cuando vuelvas al componente
  useEffect(() => {
    // provincia
    if (provinciaSeleccionada === "") {
      if (datosformulario.id_provincia !== "" && provincias) {
        const provinciaEncontrada = provincias.find(
          (d) => d.id === datosformulario.id_provincia
        );
        if (provinciaEncontrada) {
          setProvinciaSeleccionada(provinciaEncontrada);
        }
      }
    }
    // localidad
    if (localidadSeleccionada === "") {
      if (datosformulario.id_localidad !== "" && localidades) {
        const localidadEncontrada = localidades.find(
          (d) => d.id === datosformulario.id_localidad
        );
        if (localidadEncontrada) {
          setLocalidadSeleccionada(localidadEncontrada);
        }
      }
    }
    // sucursal
    if (sucursalSeleccionada === "") {
      if (datosformulario.id_sucursal !== "" && sucursales) {
        const sucursalEncontrada = sucursales.find(
          (d) => d.id === datosformulario.id_sucursal
        );
        if (sucursalEncontrada) {
          setSucursalSeleccionada(sucursalEncontrada);
        }
      }
    }
    // zona
    if (zonaSeleccionada === "") {
      if (datosformulario.zona !== "" && zonas) {
        const zonaEncontrada = zonas.find((d) => d.id === datosformulario.zona);
        if (zonaEncontrada) {
          setZonaSeleccionada(zonaEncontrada);
        }
      }
    }
  }, [datosformulario, provincias, localidades, sucursales, zonas]);
  // ************************************ ZONAS AUTOMATICAS ******************************* //
  // Geozona automática según la localidad seleccionada

  const [zonaInicialCargada, setZonaInicialCargada] = useState(false);
  useEffect(() => {
    if (props.direccion?.zona && !zonaInicialCargada) {
      // Buscar en todas las zonas disponibles si existe la zona guardada
      const zonasDisponibles = Object.values(geozonasPorDomicilio).flatMap(
        (d) => d.geozonas
      );
      const zonaGuardada = zonasDisponibles.find(
        (z) => z.id === props.direccion.zona
      );

      if (zonaGuardada) {
        setZonaSeleccionada(zonaGuardada);
        setZonaInicialCargada(true);
      }
    }
  }, [props.direccion, geozonasPorDomicilio]);

  useEffect(() => {
    const fetchGeozona = async () => {
      if (!localidadSeleccionada?.id) return;

      try {
        setLoading(true);

        const res = await fetch(
          `${UrlApi}/geozonas/xlocalidad/${localidadSeleccionada.id}`
        );
        const data = await res.json();

        setGeozonasPorDomicilio({
          [props.direccion.nro_dir]: {
            nombreDireccion: props.direccion.nombre_direccion || "Sin nombre",
            localidad: localidadSeleccionada.id,
            geozonas: data,
          },
        });
      } catch (err) {
        console.error("Error fetching geozona:", err);
        setError("Error al cargar la geozona");
      } finally {
        setLoading(false);
      }
    };

    fetchGeozona();
  }, [localidadSeleccionada?.id, props.direccion]);

  function isPointInPolygon(point, polygon) {
    const x = point.lat;
    const y = point.lng;
    let inside = false;

    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i].lat,
        yi = polygon[i].lng;
      const xj = polygon[j].lat,
        yj = polygon[j].lng;

      const intersect =
        yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
      if (intersect) inside = !inside;
    }

    return inside;
  }

  const detectarZonaPorCoordenadas = () => {
    const zonas = geozonasPorDomicilio[props.direccion.nro_dir]?.geozonas;
    const lat = parseFloat(datosformulario.latitud);
    const lng = parseFloat(datosformulario.longitud);

    if (!zonas || !lat || !lng) {
      console.warn("Faltan datos para detectar la zona");
      return;
    }

    const puntoActual = { lat, lng };

    const zonaCoincidente = zonas.find(
      (zona) =>
        zona.type === "polygon" &&
        zona.coordinates?.length >= 3 &&
        isPointInPolygon(puntoActual, zona.coordinates)
    );

    if (zonaCoincidente) {
      setZonaSeleccionada(zonaCoincidente);
    } else {
      console.warn("No se encontró zona para estas coordenadas.");
    }
  };

  return (
    <div>
      {notificacion ? (
        <Notify
          mensaje={mensaje}
          open={openSnack}
          color={"#D4EFDF"}
          severity={"success"}
          handleClose={() => props.setOpen(false)}
        />
      ) : null}
      <Dialog
        maxWidth="xl"
        open={props.open}
        onClose={() => props.setOpen(false)}
        style={{ zIndex: 1 }}
      >
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography variant="h6" align="center" color="#ffffff">
              Editar Dirección {props.direccion.direccion_entrega}
            </Typography>
          </DialogTitle>
        </Box>
        <DialogContent>
          <form>
            <Grid
              container
              spacing={1}
              direction="row"
              justify="flex-start"
              alignItems="flex-start"
            >
              <Grid container xs={7}>
                <Grid container direction="row" spacing={1.5}>
                  <Grid item xs={12}>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Ejemplo: Casa Central"
                      type="text"
                      required
                      focused
                      name="nombre_direccion"
                      label="Lugar de entrega"
                      color="primary"
                      onChange={almacenar}
                      value={datosformulario.nombre_direccion}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <BadgeIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Autocomplete
                      disabled={!provincias}
                      required
                      disableClearable
                      id="provincia"
                      style={style}
                      size={size}
                      noOptionsText={"Provincia INEXISTENTE"}
                      options={provincias}
                      autoHighlight
                      getOptionLabel={(provincia) =>
                        provincia.id + "-" + provincia.provincia
                      }
                      isOptionEqualToValue={(option, value) =>
                        option.id === value?.id
                      }
                      value={provinciaSeleccionada || null}
                      defaultValue={provinciaSeleccionada || null}
                      onChange={(event, value) => {
                        setProvinciaSeleccionada(value);
                        setBuscando(true);
                      }}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          key={option.id}
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          {option.id} - {option.provincia}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          placeholder="Tipee para buscar..."
                          {...params}
                          label="Provincia"
                          focused
                          inputProps={{
                            ...params.inputProps,
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    {buscando === true ? (
                      <TextField
                        disabled
                        focused
                        fullWidth
                        size={size}
                        label="Buscando Localidades..."
                      />
                    ) : (
                      <Autocomplete
                        disabled={!localidades}
                        required
                        disableClearable
                        id="localidad"
                        name="id_localidad"
                        style={style}
                        size={size}
                        noOptionsText={"Localidad INEXISTENTE"}
                        options={localidades}
                        autoHighlight
                        // getOptionLabel={(localidad) =>
                        //   localidad.id + "-" + localidad.localidad
                        // }
                        getOptionLabel={(localidad) =>
                          localidad.cp + " - " + localidad.localidad  // Cambiado: muestra CP en lugar de ID
                        }
                        isOptionEqualToValue={(option, value) =>
                          option.id === value?.id
                        }
                        value={localidadSeleccionada || null}
                        defaultValue={localidadSeleccionada || null}
                        onChange={(event, value) => {
                          setLocalidadSeleccionada(value);
                        }}
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            key={option.id}
                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                            {...props}
                          >
                            {/* {option.id} - {option.localidad} */}
                            {option.cp} - {option.localidad} 
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            placeholder="Tipee para buscar..."
                            {...params}
                            label="Localidad"
                            focused
                            inputProps={{
                              ...params.inputProps,
                            }}
                          />
                        )}
                      />
                    )}
                  </Grid>
                  <Grid item xs={4}>
                    <Autocomplete
                      disabled={!sucursales}
                      required
                      disableClearable
                      id="sucursal"
                      style={style}
                      size={size}
                      noOptionsText={"Sucursal INEXISTENTE"}
                      options={sucursales}
                      autoHighlight
                      getOptionLabel={(sucursal) =>
                        sucursal.id + "-" + sucursal.nombre
                      }
                      isOptionEqualToValue={(option, value) =>
                        option.id === value?.id
                      }
                      value={sucursalSeleccionada || null}
                      defaultValue={sucursalSeleccionada || null}
                      onChange={(event, value) => {
                        setSucursalSeleccionada(value);
                      }}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          key={option.id}
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          {option.id} - {option.nombre}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          placeholder="Tipee para buscar..."
                          {...params}
                          label="Sucursal"
                          focused
                          inputProps={{
                            ...params.inputProps,
                          }}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Direccion de entrega"
                      type="text"
                      required
                      focused
                      name="direccion_entrega"
                      id="direccion_entrega"
                      label="Direccion de entrega"
                      color="primary"
                      onChange={almacenar}
                      value={
                        datosformulario.direccion_entrega &&
                        datosformulario.direccion_entrega.replace(
                          /\b\w/g,
                          (l) => l.toUpperCase()
                        )
                      }
                      inputProps={{ maxLength: 200 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LocationOnIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Sr .. "
                      type="text"
                      focused
                      name="contacto"
                      label="Contacto"
                      color="primary"
                      onChange={almacenar}
                      value={datosformulario.contacto}
                      inputProps={{ maxLength: 200 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <ContactsIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="ejemplo@mail.com"
                      type="email"
                      focused
                      name="mails"
                      id="mails"
                      label="Mails"
                      color="primary"
                      onChange={almacenar}
                      value={datosformulario.mails}
                      inputProps={{ maxLength: 300 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <ContactMailIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      size="small"
                      fullWidth
                      type="number"
                      focused
                      name="telefono_1"
                      label="Telefono 1"
                      color="primary"
                      onChange={almacenar}
                      value={datosformulario.telefono_1}
                      inputProps={{
                        maxLength: 10,
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {codArg}
                          </InputAdornment>
                        ),
                      }}
                      helperText="Cód área (sin 0) + número sin el 15"
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      size="small"
                      fullWidth
                      type="number"
                      focused
                      name="telefono_2"
                      label="Telefono 2"
                      color="primary"
                      onChange={almacenar}
                      value={datosformulario.telefono_2}
                      inputProps={{
                        maxLength: 10,
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {codArg}
                          </InputAdornment>
                        ),
                      }}
                      helperText="Cód área (sin 0) + número sin el 15"
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      size="small"
                      fullWidth
                      type="number"
                      focused
                      name="telefono_3"
                      label="Telefono 3"
                      color="primary"
                      onChange={almacenar}
                      value={datosformulario.telefono_3}
                      inputProps={{
                        maxLength: 10,
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {codArg}
                          </InputAdornment>
                        ),
                      }}
                      helperText="Cód área (sin 0) + número sin el 15"
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={3}>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Latitud"
                      focused
                      name="latitud"
                      label="Latitud"
                      color="primary"
                      onChange={almacenar}
                      value={datosformulario.latitud}
                      inputProps={{ maxLength: 45 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PushPinIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Longitud"
                      focused
                      name="longitud"
                      label="Longitud"
                      color="primary"
                      onChange={almacenar}
                      value={datosformulario.longitud}
                      inputProps={{ maxLength: 45 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PushPinIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <TextField
                      focused
                      variant="outlined"
                      inputProps={{
                        maxLength: 200,
                      }}
                      fullWidth
                      size={size}
                      label="Observaciones"
                      value={datosformulario.observaciones}
                      name="observaciones"
                      onChange={almacenar}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <FormControl fullWidth>
                      <Tooltip
                        placement="top"
                        title="Productos Predeterminados"
                      >
                        <IconButton
                          onClick={() => {
                            setProductoPredeterminado(true);
                          }}
                        >
                          <PropaneIcon color="primary" />
                        </IconButton>
                      </Tooltip>
                    </FormControl>
                  </Grid>
                  <Grid item xs={11}>
                    {geozonasPorDomicilio && (
                      <Autocomplete
                        disabled={
                          !geozonasPorDomicilio[props.direccion.nro_dir]
                        }
                        options={
                          geozonasPorDomicilio[props.direccion.nro_dir]
                            ?.geozonas || []
                        }
                        getOptionLabel={(zona) =>
                          zona
                            ? `${zona.nombre}${
                                zona.descripcion ? ` - ${zona.descripcion}` : ""
                              }`
                            : "Ninguna"
                        }
                        value={zonaSeleccionada}
                        onChange={(_, newValue) => {
                          setZonaSeleccionada(newValue);
                          setZonaInicialCargada(true);
                        }}
                        disableClearable
                        renderInput={(params) => {
                          const hasCoords =
                            datosformulario.latitud && datosformulario.longitud;
                          const currentZone = geozonasPorDomicilio[
                            props.direccion.nro_dir
                          ]?.geozonas?.find(
                            (z) => z.id === zonaSeleccionada?.id
                          );

                          const isValidZone =
                            hasCoords &&
                            currentZone &&
                            isPointInPolygon(
                              {
                                lat: parseFloat(datosformulario.latitud),
                                lng: parseFloat(datosformulario.longitud),
                              },
                              currentZone.coordinates
                            );

                          return (
                            <TextField
                              {...params}
                              label="Zona"
                              size="small"
                              focused
                              helperText={
                                !hasCoords
                                  ? "Ingrese coordenadas para verificar zona"
                                  : isValidZone
                                  ? "Zona válida para estas coordenadas"
                                  : zonaSeleccionada
                                  ? "⚠️ Zona no coincide con coordenadas"
                                  : "Seleccione una zona manualmente"
                              }
                              error={
                                hasCoords && zonaSeleccionada && !isValidZone
                              }
                            />
                          );
                        }}
                      />
                    )}
                  </Grid>
                  <Grid item xs={1}>
                    <FormControl fullWidth>
                      <Tooltip
                        placement="bottom"
                        title="Asignar Zona Automaticamente"
                      >
                        <IconButton
                          aria-label="Detectar zona automáticamente"
                          onClick={detectarZonaPorCoordenadas}
                          size="small"
                          color="primary"
                        >
                          <GpsFixedIcon />
                        </IconButton>
                      </Tooltip>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container xs={5}>
                {/* ACA VA EL MAPA  */}
                <Grid container size={"grow"} direction="column" ml={1}>
                  <MapaDireccionEnv
                    setDatosDir={setDatosformulario}
                    datosDir={datosformulario}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              mt={1}
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Button
                disabled={disBtn}
                variant="contained"
                onClick={() => props.setOpen(false)}
                color="error"
              >
                Volver
              </Button>
              <Button
                disabled={disBtn}
                variant="contained"
                onClick={guardarDireccion}
                color="success"
              >
                Guardar Direccion
              </Button>
            </Grid>
          </form>
          {productoPredeterminado && (
            <DialogProPre
              open={productoPredeterminado}
              setOpen={setProductoPredeterminado}
              datosformulario={datosformulario}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default EdicionDireccionEnv;
